var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoolBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "topography-shape js-shape",
    width: "1200px",
    height: "580px",
    viewBox: "0 0 1200 580",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1800, 60) scale(2.8, 2.8) skewX(30) ",
    style: {
      position: "relative",
      zIndex: 0,
      fill: "rgb(199, 225, 243)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1650, 55) scale(2.65, 2.65) skewX(27.5) ",
    style: {
      position: "relative",
      zIndex: 1,
      fill: "rgb(184, 207, 230)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1500, 50) scale(2.5, 2.5) skewX(25) ",
    style: {
      position: "relative",
      zIndex: 2,
      fill: "rgb(169, 190, 218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1350, 45) scale(2.3499999999999996, 2.3499999999999996) skewX(22.5) ",
    style: {
      position: "relative",
      zIndex: 3,
      fill: "rgb(154, 173, 206)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1200, 40) scale(2.2, 2.2) skewX(20) ",
    style: {
      position: "relative",
      zIndex: 4,
      fill: "rgb(139, 155, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1050, 35) scale(2.05, 2.05) skewX(17.5) ",
    style: {
      position: "relative",
      zIndex: 5,
      fill: "rgb(125, 138, 181)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-900, 30) scale(1.9, 1.9) skewX(15) ",
    style: {
      position: "relative",
      zIndex: 6,
      fill: "rgb(110, 121, 169)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-750, 25) scale(1.75, 1.75) skewX(12.5) ",
    style: {
      position: "relative",
      zIndex: 7,
      fill: "rgb(95, 103, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-600, 20) scale(1.6, 1.6) skewX(10) ",
    style: {
      position: "relative",
      zIndex: 8,
      fill: "rgb(80, 86, 144)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-450, 15) scale(1.45, 1.45) skewX(7.5) ",
    style: {
      position: "relative",
      zIndex: 9,
      fill: "rgb(65, 69, 132)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-300, 10) scale(1.3, 1.3) skewX(5) ",
    style: {
      position: "relative",
      zIndex: 10,
      fill: "rgb(50, 51, 119)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-150, 5) scale(1.15, 1.15) skewX(2.5) ",
    style: {
      position: "relative",
      zIndex: 11,
      fill: "rgb(35, 34, 107)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolBackground);
export default __webpack_public_path__ + "static/media/cool-background.e50bc80438581481ea2d8be4b44dc649.svg";
export { ForwardRef as ReactComponent };